(() => {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.successNotification = this.querySelector('.product-form__cart-notification')
      this.cart = document.querySelector('cart-message')
      this.form.querySelector('[name=id]').disabled = false
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

      this.outLinkButton = document.querySelector('[name=outlink_button]')
      if (this.outLinkButton) this.outLinkButton.addEventListener('click', this.onOutlinkHandler.bind(this))
      // Added to Cart header notifications functionality to be added in a future ticket
      // this.cartNotification = document.querySelector('cart-notification')

      this.termsOfUse = document.querySelector('input[name="terms-of-use-toggle"]')
      if (this.termsOfUse) {
        this.addedTermsListener = false
        this.handleTermsOfUse()
      }
    }

    async onSubmitHandler(evt) {
      // Prevent the form from submitting
      evt.preventDefault()
      if (this.form.classList.contains('servicify__use-terms-of-use')) return

      const submitButton = this.querySelector('[type="submit"]')
      if (submitButton.classList.contains('loading')) return

      if (!(await this.checkValidity())) return

      if (!this.checkRequired()) return

      // Remove any existing error messages
      this.handleErrorMessage()

      // Disable the submit button to prevent double submissions
      submitButton.setAttribute('aria-disabled', true)
      submitButton.classList.add('loading')

      // Serialize the form data
      const formData = new FormData(this.form)

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }
      // Create a config object for the POST request
      const config = {
        method: 'POST',
        body: formData,
      }

      try {
        // Send the POST request
        let res = await fetch(`${window.akc.routes.cartAddUrl}.js`, config)
        res = await res.json()

        // Handle errors
        if (res.status) {
          this.handleErrorMessage(res.description)
          return
        }

        this.cart.renderContents(res)

        // After we implement the cart page, the cart page JS should be able to
        // handle this rather than implementing it here
        await this.handleSuccess()
      } catch (err) {
        console.error(err)
      } finally {
        // Clean up the submit button
        submitButton.classList.remove('loading')
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
        submitButton.removeAttribute('aria-disabled')
      }
    }

    onOutlinkHandler(evt) {
      evt.preventDefault();

      if (!this.checkRequired()) return

      window.location.href = this.outLinkButton.getAttribute('href')
    }

    async checkValidity() {
      let isValid = true
      const inputs = Array.from(document.querySelectorAll(`[form="${this.form.getAttribute('id')}"]`))

      inputs.forEach((input) => {
        if (input.checkValidity()) {
          input.classList.remove('product-form__input--invalid')
        } else {
          input.classList.add('product-form__input--invalid')
          isValid = false
        }
      })

      return isValid
    }

    checkRequired() {
      // Default to false
      let valid = false
      // Store a reference to all required inputs
      const requiredInputs = Array.from(document.querySelectorAll('.product-form__required-input'))

      // If there are no required inputs, return true
      if (!requiredInputs.length) return true

      // Loop through each required input
      requiredInputs.forEach((requiredInput) => {
        // Store a reference to the input
        let input = requiredInput.querySelector('input');
        // Store a reference to the notification
        let notification = requiredInput.querySelector('.product-form__required-notification')
        // Check the validity of the input
        valid = input.checkValidity()

        // If the input isn't valid, show the notification
        if (!input.checkValidity()) {
          notification.classList.remove('hidden')
        // If the input is valid, hide the notification
        } else {
          notification.classList.add('hidden')
        }
      })

      // Return the validity of the input
      return valid
    }

    // This function will handle the error message if the fetch fails
    handleErrorMessage(errorMessage = false) {
      // Remove the class that shows the success notification
      this.successNotification.classList.remove('product-form__cart-notification--show')

      // If there is an error message
      if (errorMessage) {
        // Show the error message
        window.alert(errorMessage)
      }
    }

    // Function to handle successful add to cart
    async handleSuccess() {
      // Fetch the cart
      try {
        // Fetch the cart
        let res = await fetch(`${window.akc.routes.cartUrl}.js`)
        // Parse the response
        res = await res.json()

        // Build the notification
        const successNotificationBody = `
          <p>Cart ${res.item_count} Items: ${Shopify.formatMoney(res.total_price)}</p>
          <button class="product-form__button product-form__view-cart">View Cart & Check out</button>
        `

        // Add the notification to the DOM
        this.successNotification.innerHTML = successNotificationBody.trim()
        this.successNotification.classList.add('product-form__cart-notification--show')

        // Add the view cart button event listener
        let viewCartBtn = this.successNotification.querySelector('button')
        viewCartBtn.addEventListener('click', this.handleCartRedirect.bind(this))
      } catch (err) {
        console.error(err)
      }
    }

    handleCartRedirect (event) {
      if (
        event.target != this.successNotification.querySelector('button') ||
        !this.checkRequired()
      ) return

      window.location.href = window.akc.routes.cartUrl
    }

    handleTermsOfUse () {
      let formButtonsWrapper = this.form.querySelector('.product-form__buttons')
      // listen for when from buttons are added
      let observer = new MutationObserver(this.onFormButtonChange.bind(this))
      observer.observe(formButtonsWrapper, {childList: true})
    }

    onFormButtonChange (mutations) {
      let formButtonsWrapper = this.form.querySelector('.product-form__buttons')

      mutations.forEach(function(mutation) {
        // listen for when an element is added
        if (mutation.addedNodes.length > 0) {
          let servicifyButton = formButtonsWrapper.querySelector('#digital-appointments-select-time-btn')
          let servicifyButtonContainer = formButtonsWrapper.querySelector('#digital_appointments_container')
          let bookingButton = formButtonsWrapper.querySelector('.product-form_select-a-time')

          // ensures we are only listening for when the servicify button is added
          if (
            !servicifyButtonContainer ||
            mutation.addedNodes[0] != servicifyButtonContainer
          ) return

          if (!formButtonsWrapper.classList.contains('servicify__use-terms-of-use')) {
            formButtonsWrapper.classList.add('servicify__use-terms-of-use');
          }

          servicifyButton.classList.add('hide')

          // create a "fake" booking button if it doesn't exist
          // this will look the same but will have different functions
          if (!bookingButton) {
            let bookingButtonWrapper = document.createElement('div')
            bookingButtonWrapper.innerHTML = `
              <button type="button" class="product-form_select-a-time">
                Get Started
              </button>
            `

            // insert the button as the first child to ensure proper alignment
            formButtonsWrapper.insertBefore(bookingButtonWrapper, formButtonsWrapper.firstChild)
            bookingButton = formButtonsWrapper.querySelector('.product-form_select-a-time')
          }

          if (bookingButton && this.termsOfUse.checked) {
            bookingButton.classList.add('hide')
            servicifyButton.classList.remove('hide')
          }

          // ensures we are not adding more than one listener
          if (bookingButton && !this.addedTermsListener) {
            bookingButton.addEventListener('click', function () {
              if (!this.checkRequired()) return
            }.bind(this))

            this.termsOfUse.addEventListener('change', function () {
              // reselecting servicify litener to ensure we have the correct one
              servicifyButton = document.querySelector('#digital-appointments-select-time-btn')
              bookingButton.classList.toggle('hide')
              servicifyButton.classList.toggle('hide')
            }.bind(this))

            this.addedTermsListener = true;
          }
        }
      }.bind(this))
    }
  }

  class ProductMustLoginForm extends ProductForm {
    constructor() {
      super()
      this.handleAddToCartButton()
    }

    async checkValidity() {
      if (!this.dataset.customerId) {
        window.akc.getLoginScreenset()
        return false
      }

      return new Promise((resolve) => {
        window.gigya.accounts.session.verify({
          callback: (res) => {
            // User session is not signed in or has an invalid session
            if (res.errorCode !== 0) {
              window.akc.getLoginScreenset()
              resolve(false)
            }

            resolve(super.checkValidity())
          }
        })
      })
    }

    handleAddToCartButton() {
      const customerId = this.dataset.customerId;
      const addToCartButton = document.getElementById('product-form__buttons__add-to-cart')

      if (customerId) {
        addToCartButton.disabled = true
        addToCartButton.textContent = "Add to Cart"
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm)
  }

  if (!customElements.get('product-must-login-form')) {
    customElements.define('product-must-login-form', ProductMustLoginForm)
  }
})()
